import client from '../client/client';

function jsonBlob(content) {
  return new Blob([JSON.stringify(content, null, 2)], { type: 'application/json' });
}

export async function saveBotConfig({ domainName, botName, content }) {
  const formData = new FormData();
  const fileName = `${botName}_config.json`;
  formData.append('DomainName', domainName);
  formData.append('BotName', botName);
  formData.append('File', jsonBlob(content), fileName);
  return client.postForm(`${window.config?.baseApiUrl}/chatbotsAdmin/Upload/SaveBotConfig`, formData);
}

export async function saveBotsList({ directory, fileName, content }) {
  const formData = new FormData();
  formData.append('Directory', directory);
  formData.append('FileName', fileName);
  formData.append('File', jsonBlob(content), fileName);
  return client.postForm(`${window.config?.baseApiUrl}/chatbotsAdmin/Upload/SaveBotsList`, formData);
}

export function botsAssetsFolderPath(domainName) {
  return `bots/${domainName}/assets`;
}

export async function uploadBotAsset({ domainName, fileName, file }) {
  const formData = new FormData();
  formData.append('Directory', botsAssetsFolderPath(domainName));
  formData.append('FileName', fileName);
  formData.append('File', file, fileName);
  return client.postForm(`${window.config?.baseApiUrl}/chatbotsAdmin/Upload/File`, formData);
}